<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn
        icon
        color="info"
        v-on="{ ...dialog }"
      >
        <v-icon>
          mdi-folder
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Immediate Families"
      text="Immediate family documents"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row v-if="localDependent.documents.length > 0">
          <v-col
            v-for="document in localDependent.documents"
            :key="document.id"
            cols="12"
            class="pb-0"
          >
            <v-chip
              color="blue-grey lighten-3"
              link
              :href="document.file_url"
              target="_blank"
            >
              <v-icon
                color="red"
                left
              >
                mdi-file
              </v-icon>
              <span class="text-truncate"> {{ document.file_name }} </span>
            </v-chip>

            <employee-profile-general-info-dependent-dialog-delete-document
              v-if="$hasPermissionTo(['delete dependents documents']) && !isResigned"
              :document="document"
              @deleted="$emit('updated');dialog=false"
            />
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12">
            No documents available
          </v-col>
        </v-row>

        <v-row v-if="$hasPermissionTo(['create dependents documents']) && !isResigned">
          <v-col cols="12">
            <helper-auto-upload-file-input
              v-model="file"
              :max-size-in-mb="10" 
              :max-number="5"
              :multiple="true"
              :allowed-extensions="['pdf']"
              data-vv-name="files"
              field-name="files" 
              @input="uploadDocuments"            
            >
              <span 
                slot="activator"
                class="mb-2"
              >   
                <v-btn                    
                  :disabled="progressing"
                  class="mr-2"    
                >
                  <v-icon class="mr-2">
                    mdi-cloud-upload
                  </v-icon>
                  Auto file upload
                </v-btn>
              </span>
            </helper-auto-upload-file-input>
          </v-col>

          <v-col
            cols="12"
            class="pa-0 ml-3"
          >
            <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            <span class="ml-3"> 
              {{ file ? '' : 'No file chosen (.pdf only)' }}
            </span>
            <div v-if="file">
              <div
                v-for="selectedFile in file.selectedFiles"
                :key="selectedFile.name"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="15"
                />
                <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
              </div>
            </div>
          </v-col> 
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperAutoUploadFileInput: () => import('@/components/helper/AutoUploadFileInput'),
      EmployeeProfileGeneralInfoDependentDialogDeleteDocument: () => import('@/components/hris/employee/profile/general-info/dependent/DialogDeleteDocument'),
    },
    props: {
      dependent: {
        type: Object,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        localDependent: null,
        file: null,
        progressing: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.localDependent = { ...this.dependent }
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      uploadDocuments () {
        if (this.file) {
          this.$api.hrisDependentDocuments().create(this.dependent.id, this.file.formData)
            .then((res) => {
              this.$snack({ message: res.data.status })
              this.$emit('updated')
              this.file = null
              this.dialog = false
            }).catch(e => {
              this.file = null
            })
        }
      },
    }, 
  }
</script>
